import React, {useState, useEffect} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {toast} from 'react-toastify';
import {useMutation, useQuery} from 'react-query';
import {Image, Modal, Button} from 'react-bootstrap';
import {AsyncPaginate} from 'react-select-async-paginate';
import {
    OPENIDDICTAPPLICATION_API,
    BaseGatewayImage
} from '@app/utils/apiUrl.js';
import {DeleteSingle, Get, Post} from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue
} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';
import {BrowserView, MobileView} from 'react-device-detect';
import Select from 'react-select';

const OpeniddictApplication = () => {
    const history = useHistory();
    const location = useLocation();
    // if (!location) return null;
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [openConfirmRevokeModal, setOpenConfirmRevokeModal] = useState(false);

    // let accountRoleAdmin = false;
    // const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role;
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(OPENIDDICTAPPLICATION_API.DELETE_ITEM, value, null)
    );
    const revokeAllFunc = useMutation(async () => {
        const response = await Post(
            OPENIDDICTAPPLICATION_API.REVOKE_ALL_TOKENS_AND_AUTHORIZATIONS,
            null,
            null
        );
        return response.json();
    });

    const acceptRevokeAll = () => {
        if (revokeAllFunc.isLoading) return;
        revokeAllFunc.mutate(undefined, {
            onSuccess: (result) => {
                setOpenConfirmRevokeModal(false);
                toast.success(
                    `${result.message || 'Thu hồi thành công.'} Token: ${
                        result.revokedTokens
                    }; authorization: ${result.revokedAuthorizations}.`
                );
            },
            onError: (error) => {
                toast.error(
                    error?.message || messageToast.messageToastTryCatch
                );
            }
        });
    };

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const {isLoading, isError, error, data, refetch} = useQuery(
        ['openiddictApplicationData', valueSearch, page, pageSize],
        () => {
            let model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: page,
                PageSize: pageSize
            };

            replaceHistory(page, pageSize, valueSearch ? valueSearch : '');

            return Get(OPENIDDICTAPPLICATION_API.GET_PAGING, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.OPENIDDICTAPPLICATION_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res.status === 201 || res.status === 200) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        if (
                            data != null &&
                            data.items.length === 1 &&
                            page !== 1
                        ) {
                            history.push(
                                createUrlWithParam(
                                    URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
                                    {
                                        page: page - 1,
                                        size: pageSize,
                                        search: search
                                    }
                                )
                            );
                        }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: (res) => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    console.log('OpeniddictApplication render', data);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">
                                {' '}
                                Danh sách nội dung đề nghị
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <form className="form-inline">
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="mr-2"
                                    >
                                        Hiển thị :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                </form>
                                <div className="d-flex align-items-center">
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        disabled={revokeAllFunc.isLoading}
                                        onClick={() =>
                                            setOpenConfirmRevokeModal(true)
                                        }
                                    >
                                        {revokeAllFunc.isLoading
                                            ? 'Đang thu hồi...'
                                            : 'Thu hồi toàn bộ token và authorization'}
                                    </button>
                                    <NavLink
                                        className="nav-link-reject nav-link"
                                        to={
                                            URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH
                                        }
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-info"
                                        >
                                            Thêm mới
                                        </button>
                                    </NavLink>
                                </div>
                            </div>

                            {isLoading ? (
                                <div>Đang tải...</div>
                            ) : isError ? (
                                <div>Có lỗi xảy ra: ${error.message}</div>
                            ) : (
                                <div
                                    id="example2_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                    // style={{
                                    //     marginTop: accountRoleAdmin
                                    //         ? '0px'
                                    //         : '20px'
                                    // }}
                                >
                                    <div className="row">
                                        <div
                                            className="col-sm-12"
                                            style={{overflow: 'auto'}}
                                        >
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Id ứng dụng
                                                        </th>
                                                        <th className="sorting">
                                                            Tên ứnng dụng
                                                        </th>
                                                        <th className="sorting">
                                                            Quyền ứng dụng
                                                        </th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {data != null &&
                                                data.items != null &&
                                                data.items != null &&
                                                data.items !== undefined &&
                                                data.items.length > 0 ? (
                                                    <tbody>
                                                        {data.items.map(
                                                            (item, index) => (
                                                                <tr
                                                                    key={Number(
                                                                        index
                                                                    )}
                                                                    className="odd"
                                                                >
                                                                    <td className="dtr-control sorting_1">
                                                                        {index +
                                                                            1 +
                                                                            (page -
                                                                                1) *
                                                                                pageSize}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.clientId
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.displayName
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {item.permissions?.join(
                                                                            '; '
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <ul className="nav">
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    to={createUrlWithParam(
                                                                                        URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
                                                                                        {
                                                                                            id: item.id
                                                                                        }
                                                                                    )}
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Sửa"
                                                                                        className="nav-icon font-icon fas fa-pen"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    onClick={() =>
                                                                                        deleteAction(
                                                                                            item.id,
                                                                                            item.displayName
                                                                                        )
                                                                                    }
                                                                                    to
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Xóa"
                                                                                        className="nav-icon font-icon far fa-trash-alt"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr className="txt-center">
                                                            <td colSpan="12">
                                                                Không có dữ liệu
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}
                                                <tfoot>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Id ứng dụng
                                                        </th>
                                                        <th className="sorting">
                                                            Tên ứnng dụng
                                                        </th>
                                                        <th className="sorting">
                                                            Scope ứng dụng
                                                        </th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="example2_paginate"
                                            >
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    innerClass="pagination pagination-sm no-margin pull-right"
                                                    activePage={page}
                                                    itemsCountPerPage={Number(
                                                        pageSize
                                                    )}
                                                    totalItemsCount={
                                                        data != null
                                                            ? data.totalRecords
                                                            : 0
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(number) =>
                                                        changePage(number)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                                content={confirmDelMessage}
                            />
                            <Modal
                                show={openConfirmRevokeModal}
                                onHide={() => {
                                    if (!revokeAllFunc.isLoading) {
                                        setOpenConfirmRevokeModal(false);
                                    }
                                }}
                                backdrop="static"
                                keyboard={false}
                                style={{zIndex: 9999}}
                            >
                                <Modal.Header>
                                    <Modal.Title>Xác nhận thu hồi</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Bạn có chắc chắn muốn thu hồi toàn bộ token
                                    và authorization của tất cả ứng dụng và
                                    người dùng trên hệ thống? Người dùng sẽ cần
                                    đăng nhập lại.
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        disabled={revokeAllFunc.isLoading}
                                        onClick={() =>
                                            setOpenConfirmRevokeModal(false)
                                        }
                                    >
                                        Hủy
                                    </Button>
                                    <Button
                                        variant="danger"
                                        disabled={revokeAllFunc.isLoading}
                                        onClick={acceptRevokeAll}
                                    >
                                        {revokeAllFunc.isLoading
                                            ? 'Đang thu hồi...'
                                            : 'Thu hồi toàn bộ'}
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpeniddictApplication;
